module.exports = __webpack_public_path__ + "static/media/logoOraculoChat.e5e23e71.png";